import { useUser } from "~/stores/user";
import { getDefaultRoute } from "@/utils/defaultRoute";

export default defineNuxtRouteMiddleware(async (to) => {
	if (to.path !== "/contacts" && !to.path.startsWith("/contacts/")) return;

	const userStore = useUser();

	if (!userStore.user) {
		try {
			await userStore.load();
		} catch (error) {
			return navigateTo("/auth/logout", { external: true });
		}
	}

	const fallbackRoute = getDefaultRoute(userStore.user);
	return navigateTo(fallbackRoute === to.path ? "/enrichment" : fallbackRoute);
});
